export default __webpack_public_path__ + "static/praying-boy-d83fc676d5f9390de86d6635ff34a45e.jpg";